const resolveApiUrl = (): string => {
  const configuredUrl = import.meta.env.VITE_API_URL

  if (!configuredUrl) {
    return `${window.location.protocol}//${window.location.hostname}:3001`
  }

  try {
    const url = new URL(configuredUrl)

    if (
      window.location.hostname === 'localhost'
      && url.hostname === '127.0.0.1'
    ) {
      url.hostname = 'localhost'
      return url.toString().replace(/\/$/, '')
    }

    return configuredUrl.replace(/\/$/, '')
  } catch {
    return configuredUrl.replace(/\/$/, '')
  }
}

export const apiUrl = resolveApiUrl()

export const resolveMediaUrl = (url: string): string => {
  if (/^(https?:)?\/\//.test(url) || url.startsWith('data:')) {
    return url
  }

  return `${apiUrl}${url.startsWith('/') ? url : `/${url}`}`
}

export const buildQuery = (params: Record<string, number | string | string[] | undefined>): string => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === '') {
      return
    }

    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(key, item))
      return
    }

    searchParams.set(key, String(value))
  })

  const query = searchParams.toString()

  return query ? `?${query}` : ''
}

export const requestJson = async <T>(path: string, init?: RequestInit): Promise<T> => {
  const response = await fetch(`${apiUrl}${path}`, {
    credentials: 'include',
    ...init,
    headers: {
      ...init?.headers
    }
  })

  if (!response.ok) {
    const payload = (await response.json().catch(() => ({}))) as { message?: string }
    throw new Error(payload.message ?? `Request failed with status ${response.status}`)
  }

  if (response.status === 204) {
    return undefined as T
  }

  return (await response.json()) as T
}

export const formatBytes = (value: number | null): string => {
  if (!value) {
    return '0 B'
  }

  const units = ['B', 'KB', 'MB', 'GB']
  const exponent = Math.min(Math.floor(Math.log(value) / Math.log(1024)), units.length - 1)
  const amount = value / 1024 ** exponent

  return `${amount.toFixed(amount >= 10 ? 0 : 1)} ${units[exponent]}`
}
